import React from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import { filterApplePayPaymentMethod, setReduxFields } from '../../utils/library';
import { debounce } from 'throttle-debounce';
import { connect } from 'react-redux';
import withRouterV6 from '../common/withRouterV6';
import {
  defaultTransactionValues,
  newTransactionComputation,
  paymentMethodResponse,
  disableSubmit,
  toggleNewCouponCode,
  saveNewCouponAmount
} from '../../redux/actions/transaction/transaction-action';
import { SAVE_IN_TEMP_CONVERTOR_REDUCER } from '../../redux/action-contants';
import {
  DEBOUNCE_PERIOD,
  DISABLED_PAYMENTS_METHODS,
  INSTAPOINTS,
  TRANSFER_MONEY_URL
} from '../../utils/constants';
import { API_URL_V2 } from '../../utils/config';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { makeApiCall } from '../../redux/actions/common/common-action';
import { disableLoader } from '@Redux/actions/ui-trigger';
import { CouponsModal, ModalFactory } from '@Components';
import CouponChangedModal from '../referral-coupon/CouponChangedModal';
import { saveIsNavigatedFromDashboardInitTransfer } from '@Redux/actions/dashboard';
import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';

function isValidAmount(string) {
  let value = Number(string);
  return !isNaN(value) && value > 0;
}

class CurrencyConverter extends React.Component {
  static propTypes = {
    reduxFormName: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    disable_save_and_continue: PropTypes.func,
    source_currency: PropTypes.string,
    gross_source_amount: PropTypes.any,
    destination_currency: PropTypes.string,
    destination_amount: PropTypes.any,
    coupon_code: PropTypes.string,
    coupon_amount: PropTypes.any,
    redeemed_instapoints: PropTypes.any,
    redeemed_instapoints_amount: PropTypes.any,
    is_destination_amount_last_changed: PropTypes.bool,
    children: PropTypes.func,
    refreshCallback: PropTypes.func,
    newTransactionComputation: PropTypes.func,
    onErrorChange: PropTypes.func,
    onWarningChange: PropTypes.func,
    showMessage: PropTypes.func,
    instarem_bank_account_id: PropTypes.any,
    defaultTransactionValues: PropTypes.func,
    user_session: PropTypes.object,
    userStatusReducer: PropTypes.object,
    onCurrencyConverterMount: PropTypes.func,
    onChange: PropTypes.func,
    shouldIgnorePromotion: PropTypes.func,
    applyPromotion: PropTypes.bool,
    onDefaultTransactionLoad: PropTypes.func,
    refreshInstaremBankAcc: PropTypes.any,
    updateOnBeneficiaryChange: PropTypes.any,
    beneficiary_id: PropTypes.any,
    whichPromotionApplied: PropTypes.any,
    paymentMethodResponse: PropTypes.func,
    featureToggle: PropTypes.shape({
      featureToggle: PropTypes.shape({
        toggleFeature: PropTypes.bool
      })
    }),
    noSetwhatHadChanged: PropTypes.any,
    passBeneId: PropTypes.any,
    disableSubmit: PropTypes.func,
    fetchUpsell: PropTypes.bool,
    offerDiscountId: PropTypes.string,
    newCouponCode: PropTypes.string,
    isNewCouponCodeApplied: PropTypes.bool,
    minSourceAmountForCoupon: PropTypes.number,
    dashboardCalculatorData: PropTypes.objectOf({
      source_amount: PropTypes.number,
      source_currency: PropTypes.string,
      destination_amount: PropTypes.number,
      destination_currency: PropTypes.string
    }),
    isNavigatedFromDashboardInitiateTransferClick: PropTypes.bool,
    location: PropTypes.object,
    couponCMSData: PropTypes.object,
    transactionDetails: PropTypes.shape({
      selectedBene: PropTypes.shape({
        is_dha_beneficiary: PropTypes.bool
      })
    }),
    dhaChallanAmount: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      bankAccountOptions: [],
      shouldSubmitDisabled: false,
      isPaymentMethodChanged: false
    };
    this.SOURCE_CHANGED = 'SOURCE_CHANGED';
    this.DESTINATION_CHANGED = 'DESTINATION_CHANGED';
    this.BENEFICIARY_CHANGED = 'BENEFICIARY_CHANGED';
    this.COUPON_CHANGED = 'COUPON_CHANGED';
    this.whatHadChanged = this.SOURCE_CHANGED;
    this.hadError = false;
    this.computingTransaction = false;
  }

  async componentDidMount() {
    let { refreshInstaremBankAcc, updateOnBeneficiaryChange } = this.props;
    this.onSourceCurrencyChange = this.computeTransactionCreator(this.SOURCE_CHANGED);
    //onSourceAmountChange and onDestinationAmountChange functions are used in CurrencyField component
    this.onSourceAmountChange = debounce(
      DEBOUNCE_PERIOD,
      this.computeTransactionCreator(this.SOURCE_CHANGED)
    );
    this.onDestinationAmountChange = debounce(
      DEBOUNCE_PERIOD,
      this.computeTransactionCreator(this.DESTINATION_CHANGED)
    );
    this.onDestinationCurrencyChange = this.computeTransactionCreator(this.SOURCE_CHANGED);
    //if bank id changed and last destination amount is changed, then only call below fun
    this.onBankAccountChangeWithDestinaiton = this.computeTransactionCreator(
      this.DESTINATION_CHANGED
    );
    this.loadBankAccountsDebounce = debounce(DEBOUNCE_PERIOD, this.loadBankAccounts);
    if (updateOnBeneficiaryChange)
      this.onBeneficiaryChange = this.computeTransactionCreator(this.BENEFICIARY_CHANGED);

    this.onCouponChange = debounce(
      DEBOUNCE_PERIOD,
      this.computeTransactionCreator(this.COUPON_CHANGED)
    );
    let { refreshCallback, onCurrencyConverterMount } = this.props;
    refreshCallback &&
      refreshCallback(
        this.computeTransactionCreator(
          this.props.is_destination_amount_last_changed
            ? this.DESTINATION_CHANGED
            : this.SOURCE_CHANGED,
          //to send last changed source/destination amount
          false
        )
      ); //if no transactionDetails it will return[]
    if (
      !onCurrencyConverterMount ||
      !(await onCurrencyConverterMount((transactionDetails) =>
        this.loadBankAccountsDebounce(transactionDetails, !refreshInstaremBankAcc)
      ))
    ) {
      await this.loadDefaultTransaction();
    }
    this.setState({ mainConverter: this });
  }

  async componentDidUpdate(props) {
    // noinspection EqualityComparisonWithCoercionJS
    let {
        source_currency: prevSourceCurrency,
        gross_source_amount: prevSourceAmount,
        destination_currency: prevDestinationCurrency,
        destination_amount: prevDestinationAmount,
        instarem_bank_account_id: prevBankAccountId,
        beneficiary_id: prevBeneficiary,
        newCouponCode: prevCouponCode,
        dhaChallanAmount: prevDhaChallanAmount
      } = props,
      {
        source_currency: sourceCurrency,
        gross_source_amount: sourceAmount,
        destination_currency: destinationCurrency,
        destination_amount: destinationAmount,
        instarem_bank_account_id: bankAccountID,
        beneficiary_id: beneficiary,
        shouldIgnorePromotion,
        refreshInstaremBankAcc,
        is_destination_amount_last_changed,
        newCouponCode: newCouponCodeProp,
        isNewCouponCodeApplied,
        isNavigatedFromDashboardInitiateTransferClick,
        dhaChallanAmount,
        transactionDetails
      } = this.props,
      isDhaBeneficiary = transactionDetails?.selectedBene?.is_dha_beneficiary && dhaChallanAmount,
      //eslint-disable-next-line
      fetchBankAccounts =
        prevSourceCurrency !== sourceCurrency ||
        prevDestinationCurrency !== destinationCurrency ||
        sourceAmount !== prevSourceAmount,
      // eslint-disable-next-line
      /* CODE: below will trigger if source currency changed and also if bank id changed and last source amount is changed */
      executor =
        prevSourceCurrency !== sourceCurrency ||
        (prevBankAccountId !== bankAccountID && !is_destination_amount_last_changed)
          ? this.onSourceCurrencyChange
          : // eslint-disable-next-line
          prevDestinationCurrency !== destinationCurrency
          ? this.onDestinationCurrencyChange
          : /* below will trigger if bank id changed and last destination amount is changed */
          prevBankAccountId !== bankAccountID && is_destination_amount_last_changed
          ? this.onBankAccountChangeWithDestinaiton
          : // eslint-disable-next-line
          prevBeneficiary !== beneficiary
          ? this.onBeneficiaryChange
          : sourceAmount !== prevSourceAmount && !is_destination_amount_last_changed
          ? this.onSourceAmountChange
          : prevCouponCode !== newCouponCodeProp && (newCouponCodeProp || !isNewCouponCodeApplied)
          ? this.onCouponChange
          : prevDhaChallanAmount !== dhaChallanAmount && isDhaBeneficiary
          ? this.onSourceCurrencyChange
          : null;

    /*
      Defining if coupon Need to change - if user change source currency, recipient, bank account, dest currency
    */
    const hasSourceChanged = prevSourceCurrency !== sourceCurrency;
    const hasDestinationCurrencyChanged = prevDestinationCurrency !== destinationCurrency;
    const hasBankAccountChanged = prevBankAccountId !== bankAccountID;
    const hasBeneficiaryChanged = prevBeneficiary !== beneficiary;
    const hasSourceAmountChanged = sourceAmount !== prevSourceAmount;

    const couponNeedToChange =
      !isNavigatedFromDashboardInitiateTransferClick &&
      isNewCouponCodeApplied &&
      (hasSourceChanged ||
        (hasBankAccountChanged && !is_destination_amount_last_changed) ||
        hasDestinationCurrencyChanged ||
        hasBeneficiaryChanged ||
        hasSourceAmountChanged);

    if (hasBankAccountChanged || fetchBankAccounts) this.whatHadChanged = null;
    /*
			Values in the form are not mutated if the previous hit
			had error out. Now if the user inputs
			the value equal to the value previous to that of
			the error request, the other amount doesn't change
			and the whatHadChanged goes out of sync. We reconcile
			it here
		 */
    if (this.hadError) {
      this.hadError = false;
      this.whatHadChanged = null;
    }

    //checking if something had actually changed
    if (!executor) return;

    if (couponNeedToChange) {
      const changeType =
        hasSourceChanged ||
        (hasBankAccountChanged && !is_destination_amount_last_changed) ||
        hasDestinationCurrencyChanged ||
        (hasSourceAmountChanged && !is_destination_amount_last_changed)
          ? this.SOURCE_CHANGED
          : hasBankAccountChanged && is_destination_amount_last_changed
          ? this.DESTINATION_CHANGED
          : hasBeneficiaryChanged
          ? this.BENEFICIARY_CHANGED
          : null;
      // Exclusive check for changeType so that we can send couponNeedToChange variable and source amount change
      if (changeType)
        executor = debounce(
          DEBOUNCE_PERIOD,
          this.computeTransactionCreator(
            changeType,
            true,
            couponNeedToChange,
            sourceAmount !== prevSourceAmount
          )
        );
    }

    //checking if the current change is due to prev change
    if (this.whatHadChanged && !this.props.noSetwhatHadChanged) {
      return (this.whatHadChanged = null);
    } else {
      const isCurrencyChanged =
        prevSourceCurrency !== sourceCurrency || prevDestinationCurrency !== destinationCurrency;
      const loadAccounts = isCurrencyChanged
        ? this.loadBankAccounts
        : this.loadBankAccountsDebounce;
      fetchBankAccounts &&
        (await loadAccounts(
          {
            source_currency: sourceCurrency,
            source_amount: sourceAmount,
            destination_currency: destinationCurrency,
            isCurrencyChanged
          },
          !refreshInstaremBankAcc
        ));
      await executor(
        null,
        null,
        shouldIgnorePromotion
          ? shouldIgnorePromotion({
              prevSourceCurrency,
              prevSourceAmount,
              prevDestinationCurrency,
              prevDestinationAmount,
              sourceCurrency,
              sourceAmount,
              destinationCurrency,
              destinationAmount,
              beneficiary
            })
          : false
      );
    }
  }

  initializeFormFields = (name, value) => {
    const { dispatch } = this.props;
    dispatch(change('Sendmoney', name, value));
  };

  // Initializing send money calculator form using dashboard calculator data if user came via Initiate transfer CTA
  initDashboardCalulatorData = () => {
    const { dashboardCalculatorData } = this.props;
    if (dashboardCalculatorData) {
      this.initializeFormFields('gross_source_amount', dashboardCalculatorData.source_amount);
      this.initializeFormFields('source_currency', dashboardCalculatorData.source_currency);
      this.initializeFormFields('destination_amount', dashboardCalculatorData.destination_amount);
      this.initializeFormFields(
        'destination_currency',
        dashboardCalculatorData.destination_currency
      );
    }
  };

  renderCouponModal = async (couponList) => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose) => (
        <CouponsModal
          onClose={onClose}
          couponCMSData={this.props.couponCMSData}
          couponList={couponList}
        />
      ),
      'coupons-modal-currency-converter insta-modal center-modal',
      true
    );
  };

  renderCouponChangedModal = async () => {
    //@ts-ignore
    await ModalFactory.builder(
      (onClose) => (
        <CouponChangedModal
          onClose={onClose}
          destinationCurrency={this.props.destination_currency}
          sourceAmount={this.props.gross_source_amount}
          sourceCurrency={this.props.source_currency}
          renderCouponModal={this.renderCouponModal}
        />
      ),
      'coupons-change-modal insta-modal center-modal',
      true
    );
  };

  render() {
    let { children, gross_source_amount: source_amount, destination_amount } = this.props,
      { toggleLoader } = this;
    if (!children) return null;
    return children({
      toggleLoader,
      source_amount,
      destination_amount,
      ...this.state
    });
  }
  computeTransactionCreator = (
    whatChanged,
    trackChange = true,
    couponNeedToChange = false,
    sourceAmountChanged = false
  ) => {
    return async (resolve, reject, ignorePromotion = false) => {
      if (this.computingTransaction) return;
      this.computingTransaction = true;
      let {
          source_currency: newSourceCurrency,
          gross_source_amount: newSourceAmount,
          destination_currency: newDestinationCurrency,
          destination_amount: newDestinationAmount,
          redeemed_instapoints: newInstapoints,
          instarem_bank_account_id,
          onErrorChange,
          onChange,
          onWarningChange,
          applyPromotion = false,
          beneficiary_id,
          whichPromotionApplied,
          newCouponCode,
          minSourceAmountForCoupon,
          isNavigatedFromDashboardInitiateTransferClick,
          isNewCouponCodeApplied,
          dhaChallanAmount,
          transactionDetails
        } = this.props,
        isDhaBeneficiary = transactionDetails?.selectedBene?.is_dha_beneficiary && dhaChallanAmount,
        payload = {
          source_currency: newSourceCurrency,
          destination_currency: newDestinationCurrency,
          instarem_bank_account_id
        };

      let couponRemoved = false;
      if (isNewCouponCodeApplied && whatChanged === this.DESTINATION_CHANGED) {
        couponRemoved = true;
        this.props.dispatch(toggleNewCouponCode(false));
      } else if (couponNeedToChange) {
        // Keep the same coupon if only source amount changed and its more than minSourceAmount for that coupon
        if (sourceAmountChanged && newSourceAmount >= minSourceAmountForCoupon) {
          payload.coupon_code = newCouponCode;
        } else {
          couponRemoved = true;
          this.props.dispatch(toggleNewCouponCode(false));
        }
      } else if (isNewCouponCodeApplied && newSourceAmount < minSourceAmountForCoupon) {
        couponRemoved = true;
        this.props.dispatch(toggleNewCouponCode(false));
      }

      if (
        (whatChanged === this.COUPON_CHANGED && newCouponCode) ||
        (isNavigatedFromDashboardInitiateTransferClick &&
          whatChanged !== this.DESTINATION_CHANGED) ||
        (whatChanged === this.SOURCE_CHANGED &&
          newSourceAmount >= minSourceAmountForCoupon &&
          !couponRemoved)
      ) {
        /* 
        isNavigatedFromDashboardInitiateTransferClick check needed if user have already added coupon from Dashboard.
        If user does not add coupon on Dashboard then newCouponCode will be null and payload will get eventually drop in further journey
        */
        payload.coupon_code = newCouponCode;
        payload.source_amount = Number.parseFloat(newSourceAmount);
      } else if (whatChanged === this.COUPON_CHANGED) {
        payload.source_amount = Number.parseFloat(newSourceAmount);
      }
      /**
       * we don't hit the api if we don't have either
       * currencies and if neither of them are valid
       * amounts
       */
      if (
        !Number.isInteger(instarem_bank_account_id) ||
        !newSourceCurrency ||
        !newDestinationCurrency ||
        (isDhaBeneficiary && whatChanged === this.BENEFICIARY_CHANGED
          ? !isValidAmount(dhaChallanAmount)
          : whatChanged === this.SOURCE_CHANGED
          ? !isValidAmount(newSourceAmount)
          : whatChanged === this.BENEFICIARY_CHANGED
          ? false // non-DHA bene change always uses default source_amount
          : !isValidAmount(newDestinationAmount))
      ) {
        this.computingTransaction = false;
        return resolve ? resolve(false) : false;
      }

      if (!ignorePromotion && applyPromotion && whichPromotionApplied) {
        switch (whichPromotionApplied) {
          case INSTAPOINTS:
            if (newInstapoints) {
              payload.instapoints = newInstapoints;
            }
            break;
          default:
            break;
        }
      }

      /**
       * construct the payload with accordance to what
       * the user had changed
       */
      if (whatChanged === this.SOURCE_CHANGED)
        payload.source_amount = Number.parseFloat(newSourceAmount);
      else if (whatChanged === this.DESTINATION_CHANGED) {
        payload.destination_amount = Number.parseFloat(newDestinationAmount);
        delete payload.source_amount; //Added for safety.
      } else if (whatChanged === this.BENEFICIARY_CHANGED) {
        payload.beneficiary_id = beneficiary_id;
        if (!isDhaBeneficiary) {
          payload.source_amount = 1000;
        }
      }

      if (isDhaBeneficiary) {
        payload.destination_amount = Number.parseFloat(dhaChallanAmount);
        delete payload.source_amount;
      }

      this.props.dispatch({
        type: SAVE_IN_TEMP_CONVERTOR_REDUCER,
        data: {
          is_destination_amount_last_changed: whatChanged === this.DESTINATION_CHANGED
        }
      });
      await this.toggleLoader();

      if (this.props.passBeneId) {
        payload.beneficiary_id = beneficiary_id;
      }
      //hit the api
      try {
        this.props.disableSubmit(true);
        if (this.props.fetchUpsell) payload.get_upsell = true;
        if (this.props.offerDiscountId) payload.offer_discount_id = this.props.offerDiscountId;
        let newTransaction = await this.props.newTransactionComputation(payload),
          {
            destination_validation: destination_amount,
            source_validation: gross_source_amount,
            warning_message
          } = newTransaction;
        this.props.disableSubmit(false);
        if (
          newTransaction?.data?.statusCode === 400 ||
          destination_amount ||
          gross_source_amount ||
          warning_message
        ) {
          // Clearing coupon data if compute api fails or there is any kind of error in computation api
          this.props.dispatch(toggleNewCouponCode(false));
        }
        if (isNavigatedFromDashboardInitiateTransferClick && isNewCouponCodeApplied) {
          this.props.dispatch(saveIsNavigatedFromDashboardInitTransfer(false));
        }
        if (newTransaction && couponRemoved) {
          /* If coupon removed because of Either, source validation, destination changed, 
          Bene change, showing coupon clearedmodal
          */
          this.renderCouponChangedModal();
        } else if (newTransaction?.coupon_code && payload.coupon_code) {
          //  If coupon successfully applied then save the coupon applied state.
          this.props.dispatch(toggleNewCouponCode(true));
          this.props.dispatch(saveNewCouponAmount(newTransaction?.coupon_amount));
          this.props.dispatch(disableLoader());
        }
        trackChange && (this.whatHadChanged = whatChanged);

        /**
         * this sets transactions related values in the resp form's value
         * if value is an empty string, it doesn't set the resp field
         * eg. source_validation: '', destination_validation: '', warning_message: ''
         * alike above fields, values won't set in the redux form
         */
        if (whatChanged === this.SOURCE_CHANGED && !isDhaBeneficiary) {
          newTransaction.gross_source_amount = this.props.gross_source_amount;
        } else if (whatChanged === this.DESTINATION_CHANGED) {
          newTransaction.destination_amount = this.props.destination_amount;
        }
        if (isDhaBeneficiary) {
          newTransaction.destination_amount = Number.parseFloat(dhaChallanAmount);
        }
        setReduxFields(this.props.dispatch, change, this.props.reduxFormName, newTransaction);

        this.setState({ showLoader: false, shouldSubmitDisabled: false });

        //update the parent with error if any and return
        onErrorChange &&
          onErrorChange(
            destination_amount
              ? { destination_amount }
              : gross_source_amount
              ? { gross_source_amount }
              : null
          );
        onWarningChange &&
          onWarningChange(
            !destination_amount && !gross_source_amount && warning_message
              ? { warning_message }
              : null
          );
        //notify listener of transaction update
        onChange && onChange(newTransaction);
        this.computingTransaction = false;
        return resolve ? resolve(true) : true;
      } catch (err) {
        if (payload.coupon_code) {
          // For any error in computation api while calling it via coupon_code in payload, reset coupon state
          this.props.dispatch(toggleNewCouponCode(false));
        }
        //we had an error, set and clear the relevant flags
        this.hadError = true;
        this.whatHadChanged = null;
        this.props.disableSubmit(false);

        //if error is available, notify the parent with that error
        if (err && err.data && err.data.data && err.data.data.message && onErrorChange) {
          let message = err.data.data.message || '';
          if (/amount/gi.test(message))
            onErrorChange({
              [whatChanged === this.SOURCE_CHANGED ? 'gross_source_amount' : 'destination_amount']:
                err.data.data.message
            });
          else this.props.showMessage({ text: [message], type: 'error' });
        }
        this.setState({ showLoader: false, shouldSubmitDisabled: false });
        this.computingTransaction = false;
        this.loadDefaultTransaction();

        return resolve ? resolve(false) : false;
      }
    };
  };

  loadDefaultTransaction = async () => {
    const {
      user_session: { country_code },
      defaultTransactionValues,
      dispatch,
      reduxFormName,
      onDefaultTransactionLoad,
      isNavigatedFromDashboardInitiateTransferClick,
      dashboardCalculatorData,
      location
    } = this.props;
    if (
      location.pathname.includes(TRANSFER_MONEY_URL) &&
      isNavigatedFromDashboardInitiateTransferClick &&
      !isEmpty(dashboardCalculatorData)
    ) {
      /* Since CurrencyConverter is used in Dashboard and Send money calculator added 
      check for path and isNavigatedFromDashboardInitiateTransferClick CTA
      */
      this.initDashboardCalulatorData();
    } else {
      const data = await defaultTransactionValues(country_code),
        {
          default_source_amount: gross_source_amount,
          default_source_currency: source_currency,
          default_destination_currency: destination_currency,
          default_destination_amount: destination_amount
        } = onDefaultTransactionLoad ? onDefaultTransactionLoad(data) : data;
      return setReduxFields(dispatch, change, reduxFormName, {
        gross_source_amount,
        source_currency,
        destination_currency,
        destination_amount: destination_amount ? destination_amount : undefined
      });
    }
  };

  toggleLoader = () => new Promise((resolve) => this.setState({ showLoader: true }, resolve));

  loadBankAccounts = async (props, mutateRedux = true) => {
    let data = [];
    if (!props) return data;
    let { source_amount, source_currency, destination_currency } = props;
    if (!source_amount || !source_currency || !destination_currency) return;
    try {
      const { instarem_bank_account_id } = this.props;
      let response = await makeApiCall({
          method: 'get',
          url: `${API_URL_V2}/payment-method`,
          params: {
            source_amount,
            source_currency,
            destination_currency
          },
          withCredentials: true
        }),
        { reduxFormName, dispatch } = this.props;
      if (response && response.data && response.data.success) {
        const disabledMethods = isFlagEnabled(DISABLED_PAYMENTS_METHODS)
          ? getFlagValue(DISABLED_PAYMENTS_METHODS)
          : [];
        data = response.data.data?.filter(
          (paymentMethod) => !disabledMethods.includes(paymentMethod.code)
        );

        data = filterApplePayPaymentMethod(data, this.props.userStatusReducer.email);

        if (data && data.length) {
          await new Promise((resolve) => this.setState({ bankAccountOptions: data }, resolve));
          mutateRedux &&
            !instarem_bank_account_id &&
            (await setReduxFields(dispatch, change, reduxFormName, {
              instarem_bank_account_id: data[0].value
            }));
          // If current bank account id is not in the list of available bank accounts, set the new id to first one.
          if (data.filter((pm) => pm.value === instarem_bank_account_id).length === 0) {
            await setReduxFields(dispatch, change, reduxFormName, {
              instarem_bank_account_id: data[0].value
            });
          }
        }
        // to show message in us, payment_method and  send_money.
        this.props.paymentMethodResponse(data);
      }
    } catch (e) {
      this.props.showMessage({ text: ['Something went wrong'], type: 'info' });
    }
    return data || [];
  };
}

//connect form to react-redux
function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      transactionReducer: {
        currencyCovertor: { is_destination_amount_last_changed },
        transactionDetails,
        newCouponCode,
        minSourceAmountForCoupon,
        isNewCouponCodeApplied,
        couponCMSData
      },
      userStatusReducer,
      userSessionReducer: { user_session },
      dashboardReducer: { dashboardCalculatorData, isNavigatedFromDashboardInitiateTransferClick },
      userFlowReducer: { dhaChallanData }
    },
    form
  } = reduxState;
  return {
    is_destination_amount_last_changed,
    userStatusReducer,
    user_session,
    form,
    transactionDetails,
    newCouponCode,
    minSourceAmountForCoupon,
    isNewCouponCodeApplied,
    isNavigatedFromDashboardInitiateTransferClick,
    dashboardCalculatorData,
    couponCMSData,
    dhaChallanAmount: dhaChallanData?.amount
  };
}

export default withRouterV6(
  connect(mapStateToProps, {
    newTransactionComputation,
    showMessage,
    defaultTransactionValues,
    paymentMethodResponse,
    disableSubmit
  })(CurrencyConverter)
);
